<template>
    <div>
        <v-card flat>
            <v-card-text>
                <v-form
                    v-model="valid"
                    ref="form">
                    <!-- <v-text-field
                        append-icon="mdi-magnify"
                        label="Search">
                    </v-text-field> -->
                    <v-menu
                        ref="menu"
                        v-model="displayFrom"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.from"
                                :rules="rules.from"
                                dense
                                :label="$t('date_from')"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker @input="displayFrom = false" v-model="form.from" no-title scrollable>
                        </v-date-picker>
                    </v-menu>
                    <v-menu
                        ref="menu"
                        v-model="displayTo"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.to"
                                :rules="rules.to"
                                dense
                                :label="$t('date_to')"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker @input="displayTo = false" v-model="form.to" no-title scrollable>
                        </v-date-picker>
                    </v-menu>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="search" :disabled="!valid" text> {{ $t('search') }} </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
// import moment from 'moment';
export default {
    name: 'DateRange',
    components: {
        
    },
    data() {
        return {
            valid: false,
            displayFrom: false,
            displayTo: false,
            form: {
                from: null,
                to: null,
            },
            rules: {
                from: [
                    v => !!v || this.$t('rules_required')
                ],
                to: [
                    v => !!v || this.$t('rules_required')
                ]
            }
            
        }
    },
    computed: {
        
    },
    methods: {
        search() {
            this.$emit('submit:search', this.form);
        }
    },
}
</script>